import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const ACAO = { criado: "Cadastrado", editado: "Editado", bloqueado: "Bloqueado", reativado: "Reativado",
  copiado_lista_seguranca: "Copiado da lista de segurança", removido_lista_seguranca: "Removido da lista de segurança" };

const resumo = (h, perfis) => {
  const label = (id) => perfis.find((p) => p.id === id)?.label || id;
  if (!h.antes) return `Perfil: ${label(h.depois?.perfil)}`;
  return Object.keys(h.depois || {}).filter((k) => JSON.stringify(h.antes[k]) !== JSON.stringify(h.depois[k]))
    .map((k) => k.replace("_ids", "s").replace("_", " ")).join(", ") || "sem mudança de acesso";
};

export function HistoricoDialog({ usuario, perfis = [], onClose }) {
  const [itens, setItens] = useState(null);
  useEffect(() => {
    if (!usuario) { return; }
    setItens(null);
    api.get(`/acessos/usuarios/${usuario.id}/historico`).then((r) => setItens(r.data)).catch(() => setItens([]));
  }, [usuario]);
  return (
    <Dialog open={!!usuario} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid="historico-dialog">
        <DialogHeader><DialogTitle>Histórico de permissões — {usuario?.nome}</DialogTitle></DialogHeader>
        {itens === null && <div className="text-sm text-stone-500">Carregando…</div>}
        {itens?.length === 0 && <div className="text-sm text-stone-500">Nenhum registro disponível.</div>}
        <ol className="space-y-3">
          {(itens || []).map((h) => (
            <li key={h.id} className="border-l-2 border-[#D4A652] pl-3" data-testid={`historico-item-${h.id}`}>
              <div className="text-sm font-medium text-stone-800">{ACAO[h.acao] || h.acao}</div>
              <div className="text-xs text-stone-500">{new Date(h.em).toLocaleString("pt-BR")} · por {h.por}</div>
              <div className="text-xs text-stone-600 mt-0.5">{resumo(h, perfis)}</div>
            </li>
          ))}
        </ol>
      </DialogContent>
    </Dialog>
  );
}
